import { Box, Flex } from '@chakra-ui/react'
import { ChakraPrimaryButton } from 'components/Button'
import { Image, Text } from '@chakra-ui/react'

type CTACardProps = {
  imageSrc: string
  clickHandler: () => void
  buttonText: string
}

export const CTACard = ({
  imageSrc,
  clickHandler,
  buttonText,
}: CTACardProps) => {
  return (
    <Box
      bg="#F0F6FE"
      borderRadius="8px"
      marginTop="30px"
      marginBottom="30px"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)"
      p={4}
    >
      <Flex>
        <Image
          src={imageSrc}
          height="100%"
          objectFit="contain"
          paddingTop="1"
        />
        <Box>
          <Text
            fontFamily="Instrument Serif"
            fontSize="32px"
            fontWeight="normal"
            lineHeight="32px"
          >
            <i>Nourish</i> your next step
          </Text>
          <Text fontSize="14px">
            Patients who see a Registered Dietitian with their first month
            report feeling more in control of their health and{' '}
            <strong style={{ fontWeight: 600 }}>
              get even more value out of Allara
            </strong>
            . Your RD will provide expert support on nutrition, lifestyle, and
            more.
          </Text>
          <ChakraPrimaryButton
            styleProps={{ size: 'sm' }}
            onClick={clickHandler}
          >
            {buttonText}
          </ChakraPrimaryButton>
        </Box>
      </Flex>
    </Box>
  )
}
